// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-footer{
  /* background-color: #f0f0f0; */
  margin:0;
  padding: 14px 2rem 15px 2rem;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  font-size: 14px;
  bottom: -30px;
  grid-gap:25px;
  z-index: 99;
}

.ant-layout-footer .menu{
  display: grid;
  grid-template-columns: auto auto;
  grid-gap:25px;
}
.ant-layout-footer .CopyWrites{
  display: grid;
  grid-template-columns: auto auto;
  grid-gap:5px;
}

.ant-layout-footer .CopyWrites .TuringTitle{
  font-weight: 700;
}

.launchScreen .footerWrap{

  background-color: #fff;
  font-size: 14px;
  width:100%;
  display: grid;
  align-items: flex-end;
}
.launchScreen .ant-layout-footer{
  /* background-color: #fff; */
  padding: 0 4rem 40px 4rem !important;
}

.turing-footer {
  text-align: center;
  color: #212121;
  background-color: #FCFCFC;
  padding-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/v3/components/TuringFooter/TuringFooter.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;AACtB","sourcesContent":[".ant-layout-footer{\n  /* background-color: #f0f0f0; */\n  margin:0;\n  padding: 14px 2rem 15px 2rem;\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: space-between;\n  font-size: 14px;\n  bottom: -30px;\n  grid-gap:25px;\n  z-index: 99;\n}\n\n.ant-layout-footer .menu{\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap:25px;\n}\n.ant-layout-footer .CopyWrites{\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap:5px;\n}\n\n.ant-layout-footer .CopyWrites .TuringTitle{\n  font-weight: 700;\n}\n\n.launchScreen .footerWrap{\n\n  background-color: #fff;\n  font-size: 14px;\n  width:100%;\n  display: grid;\n  align-items: flex-end;\n}\n.launchScreen .ant-layout-footer{\n  /* background-color: #fff; */\n  padding: 0 4rem 40px 4rem !important;\n}\n\n.turing-footer {\n  text-align: center;\n  color: #212121;\n  background-color: #FCFCFC;\n  padding-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
